import PropTypes from 'prop-types';
import React from 'react';
import FileThumbnail from '@unite-us/client-utils/dist/FileThumbnail';
function ListViewDocument(_ref) {
  var doc = _ref.doc;
  var openInNewWindow = function openInNewWindow(url) {
    window.open(url);
  };
  var documentTitle = doc.document.title || doc.document.name || 'Untitled';
  var documentUrl = doc.document.url;
  var iconStyle = {
    svg: {
      height: '16px',
      width: '16px',
      marginRight: '10px',
      fill: '#4A657F'
    }
  };
  return /*#__PURE__*/React.createElement("li", {
    className: "list-view-document detail-upload"
  }, /*#__PURE__*/React.createElement(FileThumbnail, {
    contentType: doc.document.content_type,
    style: iconStyle
  }), /*#__PURE__*/React.createElement("div", {
    className: "list-view-document__title"
  }, documentUrl ? /*#__PURE__*/React.createElement("a", {
    onClick: function onClick() {
      return openInNewWindow(documentUrl);
    }
  }, documentTitle) : documentTitle));
}
ListViewDocument.propTypes = {
  doc: PropTypes.shape({
    content_type: PropTypes.string.isRequired,
    id: PropTypes.string,
    name: PropTypes.string,
    pdf_url: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string
  }).isRequired,
  iconStyle: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired
};
ListViewDocument.defaultProps = {
  iconStyle: {
    svg: {
      height: '16px',
      width: '16px',
      marginRight: '10px',
      fill: '#4A657F'
    }
  }
};
export default ListViewDocument;
//# sourceMappingURL=ListViewDocument.js.map